import { createReducer, on } from '@ngrx/store';
import { DialogData, ProjektDaten } from '../../components/auswertungen-formdialog-neu/auswertungen-formdialog-neu.component';
import { loadZeitStart, loadZeitSucceeded } from '../actions/Zeit-output.actions';
import {NodeItem} from '../../../projektverwaltung/node.model';
import {getFilteredZeitFailed, getFilteredZeitStarted, getFilteredZeitSucceeded
} from '../actions/filter-seek-date.actions';
import {
  loadProjektSelectboxFailed,
  loadProjektSelectboxStart,
  loadProjektSelectboxSucceeded
} from '../../../Zeiterfassung/store/actions/project-selectbox.actions';
import {
  loadProjektauswahlNodesFailed,
  loadProjektauswahlNodesStart,
  loadProjektauswahlNodesSucceeded
} from '../actions/getProjektauswahlNodes.actions';

export interface AuswertungState {
  isLoading: boolean;
  isAddingZeiterfassung: boolean;
  item: DialogData[];
  projektDaten: ProjektDaten[];
  partProjektDaten: ProjektDaten[];
  nodes: {
    items: NodeItem[];
  };
  selectboxProjekte: NodeItem[];
}

export const initialState: AuswertungState = {
  isLoading: false,
  isAddingZeiterfassung: false,
  item: [],
  projektDaten: [],
  partProjektDaten: [],
  nodes: {
    items: [],
  },
  selectboxProjekte: [],
};


const ons = [

  on(loadZeitStart, (state: AuswertungState) => ({ ...state, isLoading: true })),
  on(loadZeitSucceeded, (state: AuswertungState, action) => ({
    ...state,
    isLoading: false,
    item: action.item,
  })),

  /* Datum und Suche beides / einzeln nach Joel */
  on(getFilteredZeitStarted, (state: AuswertungState) => ({ ...state, isLoading: true })),
  on(getFilteredZeitSucceeded, (state: AuswertungState, action) => ({
    ...state,
    item: action.item,
  })),
  on(getFilteredZeitFailed, (state: AuswertungState) => {
    return ({...state, isLoading: false});
  }),
  on(loadProjektauswahlNodesStart, (state: AuswertungState) => ({ ...state, isLoading: true })),
  on(loadProjektauswahlNodesSucceeded, (state: AuswertungState, action) => ({
    ...state,
    isLoading: false,
    selectboxProjekte: action.item,
  })),
  on(loadProjektauswahlNodesFailed, (state: AuswertungState) => ({ ...state, isLoading: false })),
];

export const auswertungenReducer = createReducer(initialState, ...ons);
